import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-dark-light text-sm leading-relaxed" data-id="element-60">
    <h3 className="font-heading text-2xl font-bold text-dark" data-id="element-61">
      Política de Privacidad
    </h3>
    <p data-id="element-62">
      <strong data-id="element-63">Última actualización:</strong> Abril 2026
    </p>
    <p data-id="element-64">
      En El Código Hormonal 40+, nos comprometemos a proteger tu privacidad.
      Esta política describe cómo recopilamos, usamos y protegemos tu
      información personal.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-65">
      1. Información que Recopilamos
    </h4>
    <p data-id="element-66">
      Recopilamos la información que nos proporcionas directamente al realizar
      una compra, como tu nombre, dirección de correo electrónico y datos de
      pago. Los datos de pago son procesados de forma segura por nuestro
      proveedor de pagos y no se almacenan en nuestros servidores.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-67">
      2. Uso de la Información
    </h4>
    <p data-id="element-68">
      Utilizamos tu información para: procesar tu compra y entregarte el
      producto digital, enviarte actualizaciones relacionadas con tu compra, y
      mejorar nuestros productos y servicios.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-69">
      3. Protección de Datos
    </h4>
    <p data-id="element-70">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tu información personal contra acceso no autorizado, alteración o
      destrucción.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-71">4. Cookies</h4>
    <p data-id="element-72">
      Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de
      navegación y analizar el tráfico del sitio. Puedes configurar tu navegador
      para rechazar cookies.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-73">5. Tus Derechos</h4>
    <p data-id="element-74">
      Tienes derecho a acceder, rectificar o eliminar tu información personal en
      cualquier momento. También puedes solicitar la portabilidad de tus datos o
      retirar tu consentimiento para el tratamiento de los mismos.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-75">
      6. Cambios a esta Política
    </h4>
    <p data-id="element-76">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Te notificaremos sobre cambios significativos a través
      del correo electrónico asociado a tu compra.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-dark-light text-sm leading-relaxed" data-id="element-77">
    <h3 className="font-heading text-2xl font-bold text-dark" data-id="element-78">
      Términos y Condiciones
    </h3>
    <p data-id="element-79">
      <strong data-id="element-80">Última actualización:</strong> Abril 2026
    </p>
    <p data-id="element-81">
      Al acceder y utilizar este sitio web y adquirir nuestros productos,
      aceptas estos términos y condiciones en su totalidad.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-82">1. Producto Digital</h4>
    <p data-id="element-83">
      El Código Hormonal 40+ es un producto digital (ebook) con materiales
      complementarios. Al completar tu compra, recibirás acceso inmediato al
      contenido digital. Este producto es para uso personal y no puede ser
      redistribuido, copiado o compartido.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-84">
      2. Garantía de Devolución
    </h4>
    <p data-id="element-85">
      Ofrecemos una garantía de satisfacción de 30 días. Si no estás satisfecha
      con el producto, puedes solicitar un reembolso completo dentro de los 30
      días posteriores a tu compra, sin preguntas.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-86">
      3. Descargo de Responsabilidad Médica
    </h4>
    <p data-id="element-87">
      Este producto es únicamente informativo y educativo. No sustituye el
      consejo médico profesional, diagnóstico o tratamiento. Siempre consulta a
      tu médico antes de comenzar cualquier programa de salud o nutrición. Los
      resultados pueden variar de persona a persona.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-88">
      4. Propiedad Intelectual
    </h4>
    <p data-id="element-89">
      Todo el contenido, incluyendo textos, imágenes, diseños y materiales
      descargables, es propiedad exclusiva de El Código Hormonal 40+ y está
      protegido por las leyes de propiedad intelectual.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-90">
      5. Limitación de Responsabilidad
    </h4>
    <p data-id="element-91">
      No nos hacemos responsables de los resultados individuales obtenidos al
      seguir el programa. Los testimonios presentados representan experiencias
      individuales y no garantizan resultados específicos.
    </p>
    <h4 className="font-bold text-dark text-base mt-4" data-id="element-92">6. Modificaciones</h4>
    <p data-id="element-93">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones entrarán en vigor inmediatamente después de su
      publicación en el sitio web.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-dark-light text-white/60 py-8 text-center text-sm" data-id="element-94">
        <div className="max-w-4xl mx-auto px-4" data-id="element-95">
          <p data-id="element-96">© 2026 El Código Hormonal 40+. Todos los derechos reservados.</p>
          <p className="mt-2 text-xs" data-id="element-97">
            Este producto no sustituye el consejo médico profesional. Los
            resultados pueden variar.
          </p>
          <div className="mt-4 flex items-center justify-center gap-6" data-id="element-98">
            <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-white transition-colors underline underline-offset-2" data-id="element-99">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-100">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-white transition-colors underline underline-offset-2" data-id="element-101">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-102">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-103">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-104">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-dark/10 hover:bg-dark/20 transition-colors text-dark" data-id="element-105">
                <X className="w-4 h-4" data-id="element-106" />
              </button>

              {activeModal === 'privacy' ? privacyContent : termsContent}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}